// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1eE8R","won":"Card_won__3KhEE","address":"Card_address__3KZss","content":"Card_content__3Ie1M","timestamp":"Card_timestamp__2ehKy"};